import { HTMLAttributes, ReactNode } from 'react';
import { t } from 'i18next';

import { CooldownView } from '@app/shared/ui/molecules/Common/CooldownView';
import notification from '@app/shared/utils/notification';
import { useItemCountdown } from '@app/shared/hooks/useItemCoundown';

export interface CooldownContainerProps extends HTMLAttributes<HTMLDivElement> {
  itemId: string;
  intervalMs: number;
  children: ReactNode;
  onClick: () => void;
  storageKey: string;
  timerClassName?: string;
}

export const CooldownContainer = ({
  itemId,
  intervalMs,
  children,
  onClick,
  storageKey,
  timerClassName,
  ...rest
}: CooldownContainerProps) => {
  const { formattedLeft, isExpired } = useItemCountdown(storageKey, itemId, intervalMs);

  const handleClick = () => {
    if (!isExpired) {
      notification.error(t(`common.available_after`, { value: formattedLeft }));
      return;
    }

    onClick();
  };

  return (
    <CooldownView
      isAvailable={isExpired}
      formattedLeft={formattedLeft}
      onClick={handleClick}
      timerClassName={timerClassName}
      {...rest}
    >
      {children}
    </CooldownView>
  );
};
